$(document).ready(function () {
    if ($("form[data-wffm]").length) {
        $("input:radio").each(function () {
            $(this).parent().append("<span class='input-state'>");
        });
        $("input:checkbox").each(function () {
            $(this).parent().append("<span class='input-state'>");
        });
    }
});
